window.actualizarTableroAcondicionamientoPeriodo = null;

if (window.location.pathname === '/acondicionamiento/periodo') {
    const contIndicadores = document.getElementById('conInfoBoxAcondicionamiento');
    const resumenCosto = document.getElementById('resumenCostoConfiguradoAcondicionamiento');
    const tablaActividades = document.querySelector('#tablaCostosActividadesAcondicionamiento tbody');
    const tablaOperarios = document.querySelector('#tablaProductividadOperariosAcondicionamiento tbody');
    const btnConfigurarCosto = document.getElementById('btnConfigurarCostoPeriodoAcondicionamiento');
    const formularioCosto = document.getElementById('formCostoPeriodoAcondicionamiento');
    const inputCosto = document.getElementById('costoTotalPeriodoAcondicionamiento');
    const paramsTableroAcondicionamiento = new URLSearchParams(window.location.search);
    const mesTableroAcondicionamiento = paramsTableroAcondicionamiento.get('mes');
    const anioTableroAcondicionamiento = paramsTableroAcondicionamiento.get('año');

    let graficoTendenciaAcondicionamiento = null;
    let graficoCostoActividadAcondicionamiento = null;
    let graficoEficienciaActividadAcondicionamiento = null;
    let costoPeriodoActualAcondicionamiento = 0;
    let costoPeriodoConfiguradoAcondicionamiento = false;

    const formatoEnteroAcondicionamiento = new Intl.NumberFormat('es-CO', {
        maximumFractionDigits: 0
    });
    const formatoDecimalAcondicionamiento = new Intl.NumberFormat('es-CO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });
    const formatoMonedaAcondicionamiento = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });

    function numeroAcondicionamiento(valor) {
        const numero = Number(valor);
        return isNaN(numero) ? 0 : numero;
    }

    function escaparHtmlAcondicionamiento(valor) {
        const texto = valor === null || valor === undefined ? '' : String(valor);
        return texto
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function formatoFechaCortaAcondicionamiento(fecha) {
        if (!fecha) return '';
        const partes = String(fecha).split('-');
        if (partes.length !== 3) return String(fecha);
        return partes[2] + '/' + partes[1];
    }

    function etiquetaActividadCortaAcondicionamiento(nombre) {
        let texto = nombre === null || nombre === undefined ? '' : String(nombre);
        texto = texto.replace(/^PROC\.\s*/i, '').replace(/CORTE DE CAPILAR EN /i, 'CAPILAR ');
        return texto.length > 30 ? texto.substring(0, 29) + '…' : texto;
    }

    function formatoMonedaCompactaAcondicionamiento(valor) {
        const numero = numeroAcondicionamiento(valor);
        const absoluto = Math.abs(numero);
        if (absoluto >= 1000000000) {
            return '$' + formatoDecimalAcondicionamiento.format(numero / 1000000000) + ' mil M';
        }
        if (absoluto >= 1000000) {
            return '$' + formatoDecimalAcondicionamiento.format(numero / 1000000) + ' M';
        }
        if (absoluto >= 1000) {
            return '$' + formatoDecimalAcondicionamiento.format(numero / 1000) + ' mil';
        }
        return formatoMonedaAcondicionamiento.format(numero);
    }

    function animacionGraficoAcondicionamiento() {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return false;
        }
        return { duration: 350 };
    }

    function colorIndiceAcondicionamiento(indice) {
        if (indice >= 100) return '#4f8f58';
        if (indice >= 85) return '#b97918';
        return '#b44949';
    }

    function destruirGraficoAcondicionamiento(grafico) {
        if (grafico) grafico.destroy();
        return null;
    }

    function obtenerElementosGraficoAcondicionamiento(tipo) {
        const ids = {
            tendencia: 'graficoTendenciaAcondicionamiento',
            costo: 'graficoCostoActividadAcondicionamiento',
            eficiencia: 'graficoEficienciaActividadAcondicionamiento'
        };
        const idCanvas = ids[tipo];
        return {
            canvas: idCanvas ? document.getElementById(idCanvas) : null,
            estado: document.querySelector('[data-estado-grafico="' + tipo + '"]')
        };
    }

    function mostrarEstadoGraficoAcondicionamiento(tipo, mensaje) {
        const elementos = obtenerElementosGraficoAcondicionamiento(tipo);
        if (elementos.canvas) {
            elementos.canvas.classList.remove('skeletonGrafico');
            elementos.canvas.hidden = true;
        }
        if (elementos.estado) {
            elementos.estado.textContent = mensaje;
            elementos.estado.hidden = false;
        }
    }

    function mostrarCanvasGraficoAcondicionamiento(tipo) {
        const elementos = obtenerElementosGraficoAcondicionamiento(tipo);
        if (elementos.canvas) {
            elementos.canvas.classList.remove('skeletonGrafico');
            elementos.canvas.hidden = false;
        }
        if (elementos.estado) {
            elementos.estado.textContent = '';
            elementos.estado.hidden = true;
        }
        return elementos.canvas;
    }

    function renderResumenCostoAcondicionamiento(resumen) {
        if (!resumenCosto) return;

        costoPeriodoActualAcondicionamiento = numeroAcondicionamiento(resumen.costoTotal);
        const configurado = Boolean(resumen.costoConfigurado);
        costoPeriodoConfiguradoAcondicionamiento = configurado;
        resumenCosto.classList.toggle('costoPendienteAcondicionamiento', !configurado);
        resumenCosto.innerHTML = '<span>Costo configurado</span>' +
            '<strong>' + (configurado ? formatoMonedaAcondicionamiento.format(costoPeriodoActualAcondicionamiento) : 'Sin configurar') + '</strong>' +
            '<small>' + (configurado
                ? formatoMonedaAcondicionamiento.format(numeroAcondicionamiento(resumen.tarifaHoraPersona)) + ' / hora-persona'
                : 'Configúralo para distribuirlo por actividad') + '</small>';
    }

    function renderIndicadoresAcondicionamiento(resumen) {
        if (!contIndicadores) return;

        const costoConfigurado = Boolean(resumen.costoConfigurado);
        const indicadores = [
            {
                etiqueta: 'Costo del periodo',
                valor: costoConfigurado ? formatoMonedaAcondicionamiento.format(numeroAcondicionamiento(resumen.costoTotal)) : 'Pendiente',
                detalle: costoConfigurado ? 'Total distribuido por horas-persona' : 'Requiere configuración',
                icono: 'produccion.svg',
                clase: costoConfigurado ? '' : 'indicadorPendienteAcondicionamiento'
            },
            {
                etiqueta: 'Costo / unidad buena',
                valor: costoConfigurado ? formatoMonedaAcondicionamiento.format(numeroAcondicionamiento(resumen.costoUnidadBuenaProcesada)) : 'Pendiente',
                detalle: 'Unidad procesada en actividades',
                icono: 'composicion.svg',
                clase: costoConfigurado ? '' : 'indicadorPendienteAcondicionamiento'
            },
            {
                etiqueta: 'Horas-persona',
                valor: formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(resumen.totalHorasPersona)) + ' h',
                detalle: formatoEnteroAcondicionamiento.format(numeroAcondicionamiento(resumen.totalOperarios)) + ' operarios con registro',
                icono: 'reloj.svg',
                clase: ''
            },
            {
                etiqueta: 'Productividad',
                valor: formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(resumen.productividadHoraPersona)),
                detalle: 'Unidades buenas / hora-persona',
                icono: 'operario.svg',
                clase: ''
            },
            {
                etiqueta: 'Calidad',
                valor: formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(resumen.calidad)) + '%',
                detalle: formatoEnteroAcondicionamiento.format(numeroAcondicionamiento(resumen.totalBuenas)) + ' unidades buenas',
                icono: 'check.svg',
                clase: ''
            },
            {
                etiqueta: 'Cumplimiento',
                valor: formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(resumen.cumplimiento)) + '%',
                detalle: formatoEnteroAcondicionamiento.format(numeroAcondicionamiento(resumen.totalTrabajadas)) + ' de ' +
                    formatoEnteroAcondicionamiento.format(numeroAcondicionamiento(resumen.totalProgramadas)),
                icono: 'turno.svg',
                clase: ''
            }
        ];

        contIndicadores.innerHTML = indicadores.map(function (indicador) {
            return '<article class="infoBox indicadorAcondicionamiento ' + indicador.clase + '">' +
                '<div class="cabeceraIndicadorAcondicionamiento">' +
                    '<h3>' + escaparHtmlAcondicionamiento(indicador.etiqueta) + '</h3>' +
                    '<img src="/public/build/img/icons/' + escaparHtmlAcondicionamiento(indicador.icono) + '" alt="" aria-hidden="true">' +
                '</div>' +
                '<p>' + escaparHtmlAcondicionamiento(indicador.valor) + '</p>' +
                '<small>' + escaparHtmlAcondicionamiento(indicador.detalle) + '</small>' +
            '</article>';
        }).join('');

        contIndicadores.classList.remove('contSkeleton');
        contIndicadores.classList.remove('cargado');
        void contIndicadores.offsetWidth;
        contIndicadores.classList.add('cargado');
    }

    function renderGraficoTendenciaAcondicionamiento(datos) {
        graficoTendenciaAcondicionamiento = destruirGraficoAcondicionamiento(graficoTendenciaAcondicionamiento);

        if (!Array.isArray(datos) || datos.length === 0) {
            mostrarEstadoGraficoAcondicionamiento('tendencia', 'No hay tabulaciones registradas para construir la tendencia.');
            return;
        }

        if (typeof Chart === 'undefined') {
            mostrarEstadoGraficoAcondicionamiento('tendencia', 'No se pudo cargar Chart.js.');
            return;
        }

        const canvas = mostrarCanvasGraficoAcondicionamiento('tendencia');
        if (!canvas) return;

        const diaMayorProduccion = datos.slice().sort(function (a, b) {
            return numeroAcondicionamiento(b.unidadesBuenas) - numeroAcondicionamiento(a.unidadesBuenas);
        })[0];
        if (diaMayorProduccion) {
            canvas.setAttribute(
                'aria-label',
                'Tendencia diaria. El día con mayor producción fue ' +
                formatoFechaCortaAcondicionamiento(diaMayorProduccion.fecha) + ' con ' +
                formatoEnteroAcondicionamiento.format(numeroAcondicionamiento(diaMayorProduccion.unidadesBuenas)) +
                ' unidades buenas.'
            );
        }

        const etiquetas = datos.map(function (item) {
            return formatoFechaCortaAcondicionamiento(item.fecha);
        });

        graficoTendenciaAcondicionamiento = new Chart(canvas, {
            type: 'bar',
            data: {
                labels: etiquetas,
                datasets: [
                    {
                        type: 'bar',
                        label: 'Unidades buenas',
                        data: datos.map(function (item) { return numeroAcondicionamiento(item.unidadesBuenas); }),
                        backgroundColor: '#0b1f3e',
                        borderRadius: 4,
                        yAxisID: 'yUnidades'
                    },
                    {
                        type: 'line',
                        label: 'Horas-persona',
                        data: datos.map(function (item) { return numeroAcondicionamiento(item.horasPersona); }),
                        borderColor: '#4f8f58',
                        backgroundColor: '#4f8f58',
                        borderWidth: 2,
                        pointRadius: 3,
                        pointHoverRadius: 5,
                        tension: 0.25,
                        yAxisID: 'yHoras'
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: animacionGraficoAcondicionamiento(),
                interaction: { mode: 'index', intersect: false },
                plugins: {
                    legend: {
                        position: 'top',
                        align: 'start',
                        labels: { usePointStyle: true, boxWidth: 8 }
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const valor = numeroAcondicionamiento(context.raw);
                                if (context.dataset.yAxisID === 'yHoras') {
                                    return context.dataset.label + ': ' + formatoDecimalAcondicionamiento.format(valor) + ' h';
                                }
                                return context.dataset.label + ': ' + formatoEnteroAcondicionamiento.format(valor);
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: { maxRotation: 0, autoSkip: true, maxTicksLimit: 12 }
                    },
                    yUnidades: {
                        beginAtZero: true,
                        position: 'left',
                        title: { display: true, text: 'Unidades buenas' },
                        grid: { color: '#edf0f3' },
                        ticks: {
                            callback: function (valor) { return formatoEnteroAcondicionamiento.format(valor); }
                        }
                    },
                    yHoras: {
                        beginAtZero: true,
                        position: 'right',
                        title: { display: true, text: 'Horas-persona' },
                        grid: { drawOnChartArea: false },
                        ticks: {
                            callback: function (valor) { return formatoDecimalAcondicionamiento.format(valor) + ' h'; }
                        }
                    }
                }
            }
        });
    }

    function renderGraficoCostoActividadAcondicionamiento(actividades, costoConfigurado) {
        graficoCostoActividadAcondicionamiento = destruirGraficoAcondicionamiento(graficoCostoActividadAcondicionamiento);

        if (!costoConfigurado) {
            mostrarEstadoGraficoAcondicionamiento('costo', 'Configura el costo del periodo para calcular su distribución.');
            return;
        }
        if (!Array.isArray(actividades) || actividades.length === 0) {
            mostrarEstadoGraficoAcondicionamiento('costo', 'No hay horas-persona registradas para distribuir el costo.');
            return;
        }
        if (typeof Chart === 'undefined') {
            mostrarEstadoGraficoAcondicionamiento('costo', 'No se pudo cargar Chart.js.');
            return;
        }

        const canvas = mostrarCanvasGraficoAcondicionamiento('costo');
        if (!canvas) return;

        const datosOrdenados = actividades.slice().sort(function (a, b) {
            return numeroAcondicionamiento(b.costoActividad) - numeroAcondicionamiento(a.costoActividad);
        }).slice(0, 10);
        if (datosOrdenados.length > 0) {
            canvas.setAttribute(
                'aria-label',
                'Costo por actividad. La actividad con mayor costo es ' + datosOrdenados[0].nombreActividad +
                ' con ' + formatoMonedaAcondicionamiento.format(numeroAcondicionamiento(datosOrdenados[0].costoActividad)) + '.'
            );
        }

        graficoCostoActividadAcondicionamiento = new Chart(canvas, {
            type: 'bar',
            data: {
                labels: datosOrdenados.map(function (item) {
                    return etiquetaActividadCortaAcondicionamiento(item.nombreActividad);
                }),
                datasets: [{
                    label: 'Costo asignado',
                    data: datosOrdenados.map(function (item) { return numeroAcondicionamiento(item.costoActividad); }),
                    backgroundColor: '#4f8f58',
                    borderRadius: 4
                }]
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                animation: animacionGraficoAcondicionamiento(),
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            title: function (contextos) {
                                if (!contextos || contextos.length === 0) return '';
                                return datosOrdenados[contextos[0].dataIndex].nombreActividad;
                            },
                            label: function (context) {
                                const actividad = datosOrdenados[context.dataIndex];
                                return [
                                    'Costo: ' + formatoMonedaAcondicionamiento.format(numeroAcondicionamiento(actividad.costoActividad)),
                                    'Participación: ' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(actividad.participacionCosto)) + '%',
                                    'Costo/unidad buena: ' + formatoMonedaAcondicionamiento.format(numeroAcondicionamiento(actividad.costoUnidadBuena))
                                ];
                            }
                        }
                    }
                },
                scales: {
                    y: { grid: { display: false } },
                    x: {
                        beginAtZero: true,
                        grid: { color: '#edf0f3' },
                        ticks: {
                            callback: function (valor) {
                                return formatoMonedaCompactaAcondicionamiento(valor);
                            }
                        }
                    }
                }
            }
        });
    }

    function renderGraficoEficienciaActividadAcondicionamiento(actividades) {
        graficoEficienciaActividadAcondicionamiento = destruirGraficoAcondicionamiento(graficoEficienciaActividadAcondicionamiento);

        const datosConReferencia = Array.isArray(actividades) ? actividades.filter(function (item) {
            return item.indiceEficiencia !== null && item.indiceEficiencia !== undefined;
        }) : [];

        if (datosConReferencia.length === 0) {
            mostrarEstadoGraficoAcondicionamiento('eficiencia', 'Se necesitan registros de meses anteriores para calcular esta referencia.');
            return;
        }
        if (typeof Chart === 'undefined') {
            mostrarEstadoGraficoAcondicionamiento('eficiencia', 'No se pudo cargar Chart.js.');
            return;
        }

        const canvas = mostrarCanvasGraficoAcondicionamiento('eficiencia');
        if (!canvas) return;

        const datosOrdenados = datosConReferencia.slice().sort(function (a, b) {
            return numeroAcondicionamiento(b.indiceEficiencia) - numeroAcondicionamiento(a.indiceEficiencia);
        }).slice(0, 10);
        if (datosOrdenados.length > 0) {
            canvas.setAttribute(
                'aria-label',
                'Eficiencia por actividad. El mayor índice corresponde a ' + datosOrdenados[0].nombreActividad +
                ' con ' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(datosOrdenados[0].indiceEficiencia)) + '.'
            );
        }

        const pluginMetaEficiencia = {
            id: 'metaEficienciaAcondicionamiento',
            afterDraw: function (chart) {
                const escalaX = chart.scales.x;
                const area = chart.chartArea;
                if (!escalaX || !area) return;

                const posicionMeta = escalaX.getPixelForValue(100);
                const contexto = chart.ctx;
                contexto.save();
                contexto.beginPath();
                contexto.setLineDash([5, 4]);
                contexto.moveTo(posicionMeta, area.top);
                contexto.lineTo(posicionMeta, area.bottom);
                contexto.lineWidth = 2;
                contexto.strokeStyle = '#0b1f3e';
                contexto.stroke();
                contexto.restore();
            }
        };

        graficoEficienciaActividadAcondicionamiento = new Chart(canvas, {
            type: 'bar',
            data: {
                labels: datosOrdenados.map(function (item) {
                    return etiquetaActividadCortaAcondicionamiento(item.nombreActividad);
                }),
                datasets: [{
                    label: 'Índice de eficiencia',
                    data: datosOrdenados.map(function (item) { return numeroAcondicionamiento(item.indiceEficiencia); }),
                    backgroundColor: datosOrdenados.map(function (item) {
                        return colorIndiceAcondicionamiento(numeroAcondicionamiento(item.indiceEficiencia));
                    }),
                    borderRadius: 4
                }]
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                animation: animacionGraficoAcondicionamiento(),
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            title: function (contextos) {
                                if (!contextos || contextos.length === 0) return '';
                                return datosOrdenados[contextos[0].dataIndex].nombreActividad;
                            },
                            label: function (context) {
                                const actividad = datosOrdenados[context.dataIndex];
                                return [
                                    'Índice: ' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(actividad.indiceEficiencia)),
                                    'Actual: ' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(actividad.productividadHoraPersona)) + ' und./h-persona',
                                    'Referencia: ' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(actividad.productividadReferencia)) + ' und./h-persona'
                                ];
                            }
                        }
                    }
                },
                scales: {
                    y: { grid: { display: false } },
                    x: {
                        beginAtZero: true,
                        suggestedMax: 120,
                        title: { display: true, text: 'Índice (meta 100)' },
                        grid: { color: '#edf0f3' },
                        ticks: {
                            callback: function (valor) { return formatoDecimalAcondicionamiento.format(valor); }
                        }
                    }
                }
            },
            plugins: [pluginMetaEficiencia]
        });
    }

    function renderTablaOperariosAcondicionamiento(operarios) {
        if (!tablaOperarios) return;

        if (!Array.isArray(operarios) || operarios.length === 0) {
            tablaOperarios.innerHTML = '<tr class="no-data"><td colspan="7"><div class="cont-no-data">' +
                'No hay registros por operario para este periodo.' +
                '<img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">' +
                '</div></td></tr>';
            return;
        }

        tablaOperarios.innerHTML = operarios.map(function (operario) {
            const indice = numeroAcondicionamiento(operario.indiceProductividad);
            const claseIndice = indice >= 100 ? 'indiceAltoAcondicionamiento' :
                (indice >= 85 ? 'indiceMedioAcondicionamiento' : 'indiceBajoAcondicionamiento');
            const nombre = escaparHtmlAcondicionamiento(operario.nombreOperario || 'Sin nombre');
            const foto = operario.fotoUsuario
                ? '/public/uploads/usuarios/' + encodeURIComponent(operario.fotoUsuario)
                : '/public/build/img/header/circulo-de-usuario.svg';
            const notaReferencia = operario.referencia === 'periodo'
                ? 'Parte del índice usa el promedio de la actividad en este periodo por falta de histórico.'
                : 'Comparado con el promedio de los seis meses anteriores.';

            return '<tr>' +
                '<td><div class="operarioProductividadAcondicionamiento">' +
                    '<img src="' + foto + '" alt="Foto de ' + nombre + '" loading="lazy">' +
                    '<span>' + nombre + '</span>' +
                '</div></td>' +
                '<td>' + escaparHtmlAcondicionamiento(operario.actividadPrincipal) + '</td>' +
                '<td>' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(operario.horasPersona)) + ' h</td>' +
                '<td>' + formatoEnteroAcondicionamiento.format(numeroAcondicionamiento(operario.unidadesBuenas)) + '</td>' +
                '<td>' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(operario.productividadHoraPersona)) + '</td>' +
                '<td>' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(operario.calidad)) + '%</td>' +
                '<td><span class="indiceProductividadAcondicionamiento ' + claseIndice + '" title="' + escaparHtmlAcondicionamiento(notaReferencia) + '">' +
                    formatoDecimalAcondicionamiento.format(indice) +
                '</span></td>' +
            '</tr>';
        }).join('');
    }

    function renderTablaActividadesAcondicionamiento(actividades, costoConfigurado) {
        if (!tablaActividades) return;

        if (!Array.isArray(actividades) || actividades.length === 0) {
            tablaActividades.innerHTML = '<tr class="no-data"><td colspan="8"><div class="cont-no-data">' +
                'No hay actividades tabuladas para este periodo.' +
                '<img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">' +
                '</div></td></tr>';
            return;
        }

        tablaActividades.innerHTML = actividades.map(function (actividad) {
            const costoActividad = costoConfigurado
                ? formatoMonedaAcondicionamiento.format(numeroAcondicionamiento(actividad.costoActividad))
                : 'Pendiente';
            const costoUnidad = costoConfigurado
                ? formatoMonedaAcondicionamiento.format(numeroAcondicionamiento(actividad.costoUnidadBuena))
                : 'Pendiente';
            const participacion = costoConfigurado
                ? formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(actividad.participacionCosto)) + '%'
                : 'Pendiente';

            return '<tr>' +
                '<td><span class="nombreActividadCostoAcondicionamiento">' + escaparHtmlAcondicionamiento(actividad.nombreActividad) + '</span></td>' +
                '<td>' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(actividad.horasPersona)) + ' h</td>' +
                '<td>' + formatoEnteroAcondicionamiento.format(numeroAcondicionamiento(actividad.unidadesBuenas)) + '</td>' +
                '<td>' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(actividad.productividadHoraPersona)) + '</td>' +
                '<td>' + formatoDecimalAcondicionamiento.format(numeroAcondicionamiento(actividad.calidad)) + '%</td>' +
                '<td class="datoCostoActividadAcondicionamiento">' + escaparHtmlAcondicionamiento(costoActividad) + '</td>' +
                '<td>' + escaparHtmlAcondicionamiento(costoUnidad) + '</td>' +
                '<td>' + escaparHtmlAcondicionamiento(participacion) + '</td>' +
            '</tr>';
        }).join('');
    }

    function renderErrorTableroAcondicionamiento(mensaje) {
        if (contIndicadores) {
            contIndicadores.classList.remove('contSkeleton');
            contIndicadores.innerHTML = '<div class="errorTableroAcondicionamiento">' + escaparHtmlAcondicionamiento(mensaje) + '</div>';
        }
        mostrarEstadoGraficoAcondicionamiento('tendencia', mensaje);
        mostrarEstadoGraficoAcondicionamiento('costo', mensaje);
        mostrarEstadoGraficoAcondicionamiento('eficiencia', mensaje);
        renderTablaActividadesAcondicionamiento([], false);
        renderTablaOperariosAcondicionamiento([]);
    }

    window.actualizarTableroAcondicionamientoPeriodo = function (mes, anio) {
        if (!mes || !anio) return Promise.resolve();

        const url = '/api/acondicionamiento/tablero-periodo?mes=' + encodeURIComponent(mes) + '&anio=' + encodeURIComponent(anio);

        return fetch(url, {
            method: 'GET',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            redirect: 'follow'
        })
            .then(function (response) {
                if (!response.ok) throw new Error('Error HTTP: ' + response.status);
                return response.json();
            })
            .then(function (respuesta) {
                if (!respuesta || !respuesta.result || !respuesta.result.resumen) {
                    throw new Error('La respuesta del tablero está incompleta.');
                }

                const data = respuesta.result;
                renderResumenCostoAcondicionamiento(data.resumen);
                renderIndicadoresAcondicionamiento(data.resumen);
                renderGraficoTendenciaAcondicionamiento(data.tendenciaDiaria);
                renderGraficoCostoActividadAcondicionamiento(data.actividades, Boolean(data.resumen.costoConfigurado));
                renderGraficoEficienciaActividadAcondicionamiento(data.actividades);
                renderTablaActividadesAcondicionamiento(data.actividades, Boolean(data.resumen.costoConfigurado));
                renderTablaOperariosAcondicionamiento(data.operarios);
            })
            .catch(function (error) {
                console.error('Error tablero acondicionamiento:', error);
                renderErrorTableroAcondicionamiento('No se pudo cargar la información del tablero.');
            });
    };

    if (btnConfigurarCosto && inputCosto) {
        btnConfigurarCosto.addEventListener('click', function () {
            inputCosto.value = costoPeriodoConfiguradoAcondicionamiento ? costoPeriodoActualAcondicionamiento.toFixed(2) : '';
            window.setTimeout(function () { inputCosto.focus(); }, 100);
        });
    }

    if (formularioCosto) {
        formularioCosto.addEventListener('submit', function (evento) {
            evento.preventDefault();

            if (!formularioCosto.checkValidity()) {
                formularioCosto.reportValidity();
                return;
            }

            const btnGuardar = document.getElementById('btnGuardarCostoPeriodoAcondicionamiento');
            const spinner = btnGuardar ? btnGuardar.querySelector('.spinner') : null;
            const mensaje = document.getElementById('mensajeCostoPeriodoAcondicionamiento');

            if (btnGuardar) btnGuardar.disabled = true;
            if (spinner) spinner.style.display = 'inline-block';
            if (mensaje) {
                mensaje.textContent = '';
                mensaje.className = 'mensajeCostoPeriodoAcondicionamiento';
            }

            fetch('/api/acondicionamiento/costo-periodo', {
                method: 'POST',
                body: new FormData(formularioCosto),
                credentials: 'include'
            })
                .then(function (response) {
                    return response.json().then(function (json) {
                        return { response: response, json: json };
                    });
                })
                .then(function (resultado) {
                    if (!resultado.response.ok || !resultado.json || resultado.json.success === false) {
                        let mensajeError = 'No se pudo guardar el costo del periodo.';
                        if (resultado.json && Array.isArray(resultado.json.errors) && resultado.json.errors.length > 0) {
                            mensajeError = resultado.json.errors[0].message || mensajeError;
                        }
                        throw new Error(mensajeError);
                    }

                    if (mensaje) {
                        mensaje.textContent = 'Costo guardado correctamente.';
                        mensaje.classList.add('mensajeCostoExitoAcondicionamiento');
                    }

                    return window.actualizarTableroAcondicionamientoPeriodo(mesTableroAcondicionamiento, anioTableroAcondicionamiento)
                        .then(function () {
                            const modal = document.getElementById('modalCostoPeriodoAcondicionamiento');
                            if (modal) modal.classList.remove('modal--show');
                            if (typeof lanzarAlerta === 'function') {
                                lanzarAlerta('Costo del periodo guardado correctamente.', 'alerta-verde');
                            }
                        });
                })
                .catch(function (error) {
                    if (mensaje) {
                        mensaje.textContent = error.message;
                        mensaje.classList.add('mensajeCostoErrorAcondicionamiento');
                    }
                })
                .finally(function () {
                    if (btnGuardar) btnGuardar.disabled = false;
                    if (spinner) spinner.style.display = 'none';
                });
        });
    }

    window.actualizarTableroAcondicionamientoPeriodo(mesTableroAcondicionamiento, anioTableroAcondicionamiento);

    window.setInterval(function () {
        window.actualizarTableroAcondicionamientoPeriodo(mesTableroAcondicionamiento, anioTableroAcondicionamiento);
    }, 120000);
}
